import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { videoId: String }
  static targets = ["player", "showWhenSeen", "hideWhenSeen"]

  connect() {
    if (window.YT && window.YT.Player) {
      this.initPlayer()
    } else {
      // Load the YouTube Iframe API script if not already present
      const tag = document.createElement("script")
      tag.src = "https://www.youtube.com/iframe_api"
      document.body.appendChild(tag)
      window.onYouTubeIframeAPIReady = () => this.initPlayer()
    }
  }

  initPlayer() {
    this.player = new YT.Player(this.playerTarget, {
      videoId: this.videoIdValue,
      playerVars: {
        controls: 0,
        rel: 0,
        disablekb: 1,
        playsinline: 1
      },
      events: {
        onStateChange: this.onPlayerStateChange.bind(this)
      }
    })
  }

  onPlayerStateChange(event) {
    if (event.data === YT.PlayerState.ENDED) {
      this.showWhenSeenTarget.classList.add("is-visible")
      this.hideWhenSeenTarget.classList.add("invisible")
    }
  }
}
